import { useRouter } from 'next/router';

import { Button } from 'glossDS/Button/Button';
import { GlossDS } from 'glossDS/GlossDS';
import { GlossIcon } from 'glossDS/Icons/GlossIcon/GlossIcon';
import { Text } from 'glossDS/Typography/Text/Text';

import {
  CLOSE_BAG_LABEL,
  KEEP_SHOPPING,
  PROCEED_TO_CHECKOUT,
} from 'routes/checkout/bag/Bag.dictionary';

import { BAG, SIGN_OUT, VIEWING_AS } from './OverlayBag.dictionary';

import styles from './OverlayBag.module.css';

type Props = {
  className?: string;
  onClose: () => void;
};

export const OverlayBag = ({ onClose, className }: Props) => {
  const router = useRouter();

  const handleProceedToCheckout = () => {
    onClose();
    void router.push('/checkout');
  };

  const handleKeepShopping = () => {
    onClose();
    void router.replace('/');
  };

  return (
    <GlossDS rebrand>
      <div>
        <div className={className}>
          <div className={styles.overlayBagHeader}>
            <Button
              className={styles.overlayCloseButton}
              appearance="transparent"
              onClick={onClose}
              aria-label={CLOSE_BAG_LABEL}
              leftSection={<GlossIcon icon="close-outline" size={24} />}
            />
            <Text className={styles.overlayBagHeaderTitle} type="bold">
              {BAG}
            </Text>
          </div>

          <div className={styles.overlayItems}></div>
          <div className={styles.overlaySummary}></div>
          <div className={styles.overlayFooter}>
            <Button
              appearance="primary"
              onClick={handleProceedToCheckout}
              className={styles.overlayFooterAction}
            >
              {PROCEED_TO_CHECKOUT}
            </Button>
            <Button
              appearance="secondary"
              onClick={handleKeepShopping}
              className={styles.overlayFooterAction}
            >
              {KEEP_SHOPPING}
            </Button>
            <div className={styles.overlayFooterDetails}>
              <Text size="sm" semanticColor="secondary">
                {VIEWING_AS('test@test.com')}
              </Text>
              <Text size="sm" semanticColor="secondary">
                {SIGN_OUT}
              </Text>
            </div>
          </div>
        </div>
      </div>
    </GlossDS>
  );
};
